import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { EditTranslationsDialog } from "../editTranslationsDialog";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditTicketUrgency extends React.Component<EditTicketUrgencyGridProps, EditTicketUrgencyGridState> {
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._saveUrgency();
                },
                primary: true
            }
        ],
        afterClose: () => {            
            this.setState({ dialogOpen: false });
        },
        width: 500
    };


    constructor(props) {
        super(props);
        this.state = { gridData: [], dialogOpen: false, currentUrgency: null, enableDeleteButton: false };
    }

    private _saveUrgency = () => {
        HTTPService.post("ProcedureLookup/SaveUrgency", { key: this.state.currentUrgency.key, value: this.state.currentUrgency.value })
            .then(result => { this._getGridData() });
    }

    private _getGridData = () => {
        const url = "ProcedureLookup/GetAllUrgencies";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }


    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createkeyBox()}
                        {this._createDescriptionTextBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createkeyBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        if (Helper.hasValue(this.state.currentUrgency)) {
            props.value = Helper.getValueOrDefault(this.state.currentUrgency.key, "");
        }
        props.disabled = true;

        props.field.maxLength = 30;        
        return (
            <FieldInstance label={this.props.context.translations["Standard.Key"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createDescriptionTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        if (Helper.hasValue(this.state.currentUrgency)) {
            props.value = Helper.getValueOrDefault(this.state.currentUrgency.value, "");
        }

        props.field.maxLength = 30;
        props.onChange = (field: { model: string, name: string }, value: any) => {

            let cu = this.state.currentUrgency;
            cu.value = value;
            this.setState({ currentUrgency: cu });

        }
        return (           
            <FieldInstance label={this.props.context.translations["Standard.Beschreibung"]} noHover={true}>
                <div style={{  }}>
                    <TextBox {...props} />
                    <EditTranslationsDialog
                        info={{
                            id: this.state.currentUrgency.key,
                            context: "ticketUrgency"
                        }}
                        onDialogClose={() => { this._openDialog(this.state.currentUrgency) }}
                        onDialogOpen={() => { this._saveUrgency() }}
                        checkId={() => { return !Helper.isNullOrEmpty(this.state.currentUrgency.value)}}
                        translations={this.props.context.translations}
                        storageKey={"TicketUrgency"}
                        
                    />
                </div>
            </FieldInstance>
        );
    }

    private _openDialog = (dataItem: data = null) => {
        let url = "ProcedureLookup/GetUrgency";
        if (dataItem)
            url += "?Id=" + dataItem.key;
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ dialogOpen: true, currentUrgency: result.Data });
                }
            });
    }

    private _delete = (dataItem: data) => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>("ProcedureLookup/DeleteUrgency?Id=" + dataItem.key)
                    .then(result => {

                        if (result.Code == 0) {
                            this._getGridData()
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }

                    });
            }
        });

    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: data) => {
        if (type == ToolBarStandardButtonType.NEW) {            
            
        } else if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        } 

        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem);
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog();
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true });


        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.editTicketUrgencyGridOptions} id="generalSettings_TicketUrgenciesGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} onSelectionChanged={this._onSelectionChanged} />
        );
        return (grid)
    }

    _onSelectionChanged = (dataItem: data) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.isDeletable });
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>
                    {grid}
                    {dialog}
                </div>
            </div>);

    }
};

interface EditTicketUrgencyGridProps {
    context: ContextGeneralSettingsApp;
}

interface EditTicketUrgencyGridState {
    gridData: data[];
    enableDeleteButton: boolean;
    dialogOpen: boolean;
    currentUrgency: data;
}

interface data {
    key: number;
    value: string;
    isDeletable: boolean;
}